<template>
  <div>
    <div class="white mx-2 mt-2 px-7 py-5 d-flex flex-column text-center rounded-lg">
      <div class="text-center" style="line-height: 1.2 !important">
        <h2 class="mb-3">Create your user account</h2>
        How do you want to login?  Choose cell phone or email below.  This is also
        how you will receive leads.
      </div>
  
      <div class="text-center mt-3" style="font-size: 12px; line-height: 1.2 !important">
        * Your information will not be shared outside of the PartnerLists app. 
      </div>
    </div>
    <div class="white ma-2 pa-4 d-flex flex-column text-center rounded-lg">
      <v-form ref="form" @submit.prevent="create">
        <v-text-field
          v-model="name"
          outlined dense hide-details="auto"
          label="Your Name"
          :rules="[required]"
          validate-on-blur
        />

        <v-select
          v-model="contact_method"
          label="Login Preference"
          outlined dense hide-details="auto"
          placeholder="Choose contact type"
          :items="[ { text: 'Email', value: 'email' }, { text: 'Cell Phone', value: 'phone' }]"
          :rules="[required]"
          class="mt-5"
          @change="contact=''"
        />
        <v-text-field
          v-if="contact_method === 'email'"
          v-model="contact"
          outlined dense hide-details="auto"
          label="Email"
          :rules="[required, valid_email]"
          validate-on-blur
          class="mt-5"
        />

        <v-text-field
          v-else
          v-model="contact"
          outlined dense hide-details="auto"
          label="Cell Phone"
          v-mask="'(###) ###-####'"
          :rules="[required, valid_us_phone]"
          validate-on-blur
          class="mt-5"
        />

        <v-btn class="mt-6" color="primary" type="submit">Create User</v-btn>
      </v-form>
    </div>
    <ErrorOverlay
      title="Error creating user" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </div>
</template>

<script>
import { ErrorOverlay } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'
import { required, valid_email, valid_us_phone } from '@/lib/validations'

export default {
  // lol, you said procreate.
  name: 'ProCreateView',

  props: ['pro_token'],

  components: { ErrorOverlay },

  data() {
    return {
      contact_method: 'email',
      name: '',
      contact: '',

      // error handling
      loading: false,
      error_dialog: false,
      error_message: '',

      // validation rules
      required,
      valid_email,
      valid_us_phone,
    }
  },

  computed: {
    ...mapGetters('auth', ['unclaimedPro'])
  },

  methods: {
    ...mapActions('auth', ['createUserFromToken', 'loadUnclaimedPro']),
    
    async create() {
      if (this.$refs.form.validate()) {
        let payload = {
          pro_token: this.pro_token,
          contact_method: this.contact_method,
          contact: this.contact,
          name: this.name,
        }

        this.loading = true
        const result = await this.createUserFromToken(payload)
        this.loading = false
        if (result.ok) {
          let { claim_token } = result.created
          this.$router.push({ name: 'claim/verify', params: { claim_token } })
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },

  async created() {
    const result = await this.loadUnclaimedPro(this.pro_token)
    if (result.ok) {
      this.name = this.unclaimedPro.contact_name
      if (this.unclaimedPro.phone) {
        this.contact_method = 'phone'
        this.contact = this.unclaimedPro.phone
      } else {
        this.contact_method = 'phone'
        this.contact = this.unclaimedPro.phone
      }
    }
  },
}
</script>